<template>
    <div class="modal-container standard save__prompt" v-if="showModal && !loading">
        <div class="header-rainbow"></div>
        <button v-on:click="close()" class="close">
            <Icon icon="close"></Icon>
        </button>
        <PromptHeader></PromptHeader>
        <div class="title-line">
            <div class="user-choices" v-if="showActions">
                {{ $t('share.choose-option') }}
            </div>
        </div>
        <div class="bun-galaxy">
            <main>
                <RainbowTitle :title="curRecipe.name" :font-size="25" :row-length="250"></RainbowTitle>
                <div class="share-bun">
                    <div class="bun__glow"></div>
                    <ShareBun></ShareBun>
                </div>
            </main>
            <div class="socialmedias">
                <SolarSystem :showActions="showActions" v-on:userInteraction="userInteraction"></SolarSystem>
            </div>

            <div class="bun-link" v-if="shareStatus > 1">
                <div>
                    <div class="share__link_title" v-if="shareStatus==2 || shareStatus==4">{{ $t('share.your-bun') }}</div>
                    <div class="share__link_title" v-else-if="shareStatus==3">{{ $t('share.thanks-for-sharing') }}</div>
                    <div class="share-link">
                        <a :href="shareUrl" target="_blank">{{ shareUrl }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal__buttons">
            <button v-on:click="back()" class="cancel">{{ $t('buttons.back') }}</button>
            <!--            <button v-on:click="accept()" class="save">{{ $t('buttons.yes') }}</button>-->
        </div>
    </div>
</template>

<script>
  import Prompt from './Prompt'
  import RainbowTitle from './RainbowTitle'
  import SolarSystem from './SolarSystem'
  import ShareBun from './ShareBun'

  export default {
    name: 'SavePrompt',
    components: { ShareBun, SolarSystem, RainbowTitle },
    extends: Prompt,
    // mounted () {
    //   // @todo remove after styling
    //   this.show()
    // },

    data: function () {
      return {
        platforms: {
          link: '',
          mail: '',
          contact: '',
          facebook: 'https://www.facebook.com/sharer.php?u=###url###',
          twitter: 'https://twitter.com/share?text=###title###&url=###url###',
          xing: 'https://www.xing.com/app/user?op=share;url=###url###',
          linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=###url###'
        }
      }
    },

    computed: {
      loading() {
        return this.$store.getters.loading
      },

      curRecipe () {
        return this.$store.state.curRecipe
      },

      contactEmail () {
        return this.$store.state.contactEmail
      },

      showActions () {
        return this.shareStatus <=1
      },

      savingCompleted () {
        return this.shareStatus && this.responseReady
      },

      shareStatus: {
        get () {
          return this.$store.getters.shareStatus
        },
        set (value) {
          this.$store.commit('setShareStatus', value)
        }
      },

      responseReady: function () {
        // return true; // @todo remove after styling
        if (this.$store.state.responseReady) {
          // don't show sharer if contact form is opened
          if (this.$store.state.showContact)
            return false
          else
            return true
        } else {
          // this.hide();
          return false
        }
      },

      shareUrl() {
        return this.$store.getters.shareUrl
      },
    },

    methods: {
      userInteraction (platform) {

        let link = this.platforms[platform]

        // ensure platform share link exists
        if (link === undefined)
          return

        if (this.shareStatus < 1) {
          this.$store.dispatch('saveRecipe')
            .then((response) => {
              this.$store.commit('setShareStatus', 'saved')
              this.executeInteraction(platform, link)
            })
        } else {
          this.executeInteraction(platform, link)
        }
      },

      executeInteraction (platform, link) {
        // generate title
        let title = encodeURIComponent(this.$t('share.share-title') + this.curRecipe.name)

        // check for mail
        if (platform === 'link') {
          this.$store.commit('setShareStatus', 'link')
          // window.location.href = 'mailto:' + this.contactEmail + '?subject=' + title + '&body=' + this.shareUrl;
        } else if(platform === 'contact') {
          this.$store.commit('setShareStatus', 'contact')
          this.$store.commit('setContactStatus', true);
        } else {
          // apply share link
          link = link.replace('###url###', this.shareUrl)

          // apply share title
          link = link.replace('###title###', title)

          // open new window
          // window.open(link, '_blank')
          /**
           * hack to get around Safarie's pop-up blocker
           */
          const fakeLink = document.createElement('a');
          fakeLink.target = '_blank';
          fakeLink.href = link;
          fakeLink.click();

          this.$store.commit('setShareStatus', 'linkedIn')
        }
      },

      accept: function () {
        this.showModal = true
        this.$store.commit('setStep', 2)
        this.$store.dispatch('saveRecipe')
      },

      back() {
        if(this.shareStatus <= 1) {
          this.close()
        } else {
          this.shareStatus = 1;
        }
      },

      close: function () {
        this.hide()
        this.$store.commit('resetShareStatus')
        this.$store.commit('showModalCover', false)
      }
    }
  }
</script>
